import * as React from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import UnityFrame from "../components/UnityFrame";
import { useEffect, useState } from "react";

function HomePage() {
  useEffect(() => {  });

  return <StyledEngineProvider injectFirst>
      <UnityFrame />
  </StyledEngineProvider>;
}

export default HomePage;